"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildWatchFragmentWhereQuery = exports.buildWatchFragmentQuery = void 0;
const core_1 = require("@apollo/client/core");
function _generateQueryFromFragment({ fieldName, fragmentDefinition, }) {
    return {
        kind: 'Document',
        definitions: [
            {
                directives: [],
                variableDefinitions: [],
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            arguments: [],
                            kind: "Field",
                            name: { kind: "Name", value: fieldName },
                            directives: [
                                {
                                    arguments: [],
                                    kind: 'Directive',
                                    name: { kind: "Name", value: "client" },
                                },
                            ],
                            selectionSet: fragmentDefinition.selectionSet,
                        },
                    ]
                },
            }
        ],
    };
}
// Returns a query that can be used to watch a normalized cache entity by converting the fragment to a query
// and dynamically adding a type policy that returns the entity.
function buildWatchFragmentQuery(options) {
    const { fragment, id, policies, fieldName } = options;
    const fragmentDefinition = fragment.definitions[0];
    const query = _generateQueryFromFragment({
        fragmentDefinition: fragmentDefinition,
        fieldName,
    });
    // @ts-ignore The getFieldPolicy is private but we need it here to determine
    // if the dynamic type policy we generate for the corresponding fragment has
    // already been added
    if (!policies.getFieldPolicy('Query', fieldName)) {
        policies.addTypePolicies({
            Query: {
                fields: {
                    [fieldName]: {
                        read(_existing) {
                            return (0, core_1.makeReference)(id);
                        }
                    }
                }
            }
        });
    }
    return query;
}
exports.buildWatchFragmentQuery = buildWatchFragmentQuery;
// Returns a query that can be used to watch a filtered list of normalized cache entities by converting the fragment to a query
// and dynamically adding a type policy that returns the list of matching entities.
function buildWatchFragmentWhereQuery(options) {
    const { fragment, filterVar, limitVar, orderByVar, policies, cache, fieldName, } = options;
    const fragmentDefinition = fragment.definitions[0];
    const __typename = fragmentDefinition.typeCondition.name.value;
    const query = _generateQueryFromFragment({
        fragmentDefinition,
        fieldName,
    });
    // @ts-ignore The getFieldPolicy is private but we need it here to determine
    // if the dynamic type policy we generate for the corresponding fragment has
    // already been added
    if (!policies.getFieldPolicy('Query', fieldName)) {
        policies.addTypePolicies({
            Query: {
                fields: {
                    [fieldName]: {
                        read(_existing) {
                            return cache.readReferenceWhere({
                                __typename,
                                filter: filterVar(),
                                limit: limitVar(),
                                orderBy: orderByVar(),
                            });
                        }
                    }
                }
            }
        });
    }
    return query;
}
exports.buildWatchFragmentWhereQuery = buildWatchFragmentWhereQuery;
//# sourceMappingURL=utils.js.map